export class SupportTicketListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            supportTicket: lang.ticket[0],
            all: lang.ticket[19],
            openStatus: lang.ticket[10],
            closedStatus: lang.ticket[11],
            viewed: lang.ticket[12],
            unViewed: lang.ticket[13],
            replied: lang.ticket[14],
            noReplied: lang.ticket[15],
            ticketNo: lang.ticket[1],
            category: lang.ticket[2],
            created: lang.ticket[3],
            status: lang.ticket[4],
            open: lang.ticket[6],
            closed: lang.ticket[7],
            action: lang.ticket[5],
            viewTicket: lang.ticket[8],
            closeTicket: lang.ticket[9],
        }

    }

    lang() {
        return this.variables;
    }

}

export class SupportTicketCreateLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            supportTicket: lang.ticket[0],
            createTicket: lang.ticket[16],
            category: lang.ticket[21],
            description: lang.ticket[20],
        }

    }

    lang() {
        return this.variables;
    }

}

export class SupportTicketViewLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            supportTicket: lang.ticket[0],
            viewTicket: lang.ticket[8],
            ticketNo: lang.ticket[1],
            category: lang.ticket[2],
            created: lang.ticket[3],
            open: lang.ticket[6],
            closed: lang.ticket[7],
            sendReply: 'Send Reply'
        }

    }

    lang() {
        return this.variables;
    }

}